import React from "react";
import { Input } from "../input";
import Select from "../select";
import CheckoutContext from "../../../checkout-context";
import { fetchCocDetails } from "../../../utils/fetchCocDetails";

class BillingData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cocFieldMessage: "",
    };
  }

  static contextType = CheckoutContext;

  handleInvoiceOptionSelect = () => {
    const { data: checkoutData, setCompanyInvoiceDetails } = this.context;
    const { customerData } = checkoutData;

    this.setState({
      cocFieldMessage: "",
    });

    if (customerData.invoiceToCompany) {
      setCompanyInvoiceDetails({ address: {} });
    } else {
      setCompanyInvoiceDetails(null);
    }
  };

  getCocDetails = (key) => {
    const {
      initialCheckoutData,
      textsMapping,
      cocEndpointUrl,
      getData,
      setData,
      updateFieldValidity,
    } = this.context;

    const { invoiceAddress: initialinvoiceAddress } =
      initialCheckoutData.customerData;

    let hadInitialinvoiceAddress = false;

    if (initialinvoiceAddress) {
      const { name, zip, houseNumber, houseNumberAddition, street, city } =
        initialinvoiceAddress;

      hadInitialinvoiceAddress = Boolean(
        name || zip || houseNumber || houseNumberAddition || street || city
      );
    }

    const cocNumber = getData(key);
    fetchCocDetails(cocEndpointUrl, cocNumber)
      .then((json) => {
        const { isValid, name, address } = json;

        this.setState({
          cocFieldMessage: isValid
            ? textsMapping.cocValid
            : textsMapping.cocInvalid,
        });

        if (!isValid || !address) return;
        if (hadInitialinvoiceAddress) return; // don't autofill, when the user already had company details filled in

        const keys = {
          name: "customerData.companyInvoiceDetails.selectedCompany.name",
          zip: "customerData.companyInvoiceDetails.selectedCompany.address.zip",
          houseNumber:
            "customerData.companyInvoiceDetails.selectedCompany.address.houseNumber",
          houseNumberAddition:
            "customerData.companyInvoiceDetails.selectedCompany.address.houseNumberAddition",
          street:
            "customerData.companyInvoiceDetails.selectedCompany.address.street",
          city: "customerData.companyInvoiceDetails.selectedCompany.address.city",
        };

        setData(keys.name, name || "");
        updateFieldValidity(
          keys.name,
          "text",
          name,
          textsMapping.inputErrorMessageDefault
        );

        setData(keys.zip, address.zip || "");
        updateFieldValidity(
          keys.zip,
          "text",
          address.zip,
          textsMapping.inputErrorMessageDefault
        );

        setData(keys.houseNumber, address.houseNumber || "");
        updateFieldValidity(
          keys.houseNumber,
          "text",
          address.houseNumber,
          textsMapping.inputErrorMessageDefault
        );

        setData(keys.houseNumberAddition, address.houseNumberAddition || "");
        updateFieldValidity(
          keys.houseNumberAddition,
          "text",
          true,
          textsMapping.inputErrorMessageDefault
        );

        setData(keys.street, address.street || "");
        updateFieldValidity(
          keys.street,
          "text",
          address.street,
          textsMapping.inputErrorMessageDefault
        );

        setData(keys.city, address.city || "");
        updateFieldValidity(
          keys.city,
          "text",
          address.city,
          textsMapping.inputErrorMessageDefault
        );
      })
      .catch((err) => {
        this.setState({
          cocFieldMessage: textsMapping.serverError,
        });
        return err;
      });
  };

  render() {
    const {
      data: checkoutData,
      textsMapping,
      trimInput,
      companyAddressNotFoundErrorMessage,
      getCompanyAddressDetails,
      defaultCountryRadioButtonChanged,
    } = this.context;

    const { countries, customerData } = checkoutData;

    if (customerData.hasAddress) {
      return null;
    }

    const { cocFieldMessage } = this.state;

    return (
      <section className="billing-data">
        <span className="billing-data-title">
          {textsMapping.billingDataTitle}
        </span>

        <section className="checkout-section">
          <h3 className="checkout-section__title">
            {textsMapping.billingDataChoiceTitle}
          </h3>
          <p>{textsMapping.billingDataChoiceText}</p>

          <Input
            inputType="radio"
            radioGroupName="billingData"
            radioButtons={[
              { name: textsMapping.billingDataForMeLabel, value: false },
              { name: textsMapping.billingDataForCompanyLabel, value: true },
            ]}
            defaultValue={
              customerData.companyInvoiceDetails.selectedCompany != null
            }
            onChangeFunction={() => this.handleInvoiceOptionSelect()}
            path="customerData.invoiceToCompany"
          />
        </section>

        {customerData.invoiceToCompany && (
          <>
            <section className="checkout-section billing-data-address">
              <h3 className="checkout-section__title">
                {textsMapping.billingDataCompanyTitle}
              </h3>
              <p>{textsMapping.billingDataCompanyText}</p>

              <Input
                resourcedTexts={textsMapping}
                inputType="text"
                inputLabel={textsMapping.companyDetailsChamberOfCommerceLabel}
                placeHolder={
                  textsMapping.companyDetailsChamberOfCommercePlaceholder
                }
                path="customerData.companyInvoiceDetails.selectedCompany.chamberOfCommerce"
                onBlurFunction={(key) => this.getCocDetails(key)}
                required
                allowNumbersOnly
              />

              {cocFieldMessage && (
                <p className="address-error-messsage">{cocFieldMessage}</p>
              )}

              <Input
                resourcedTexts={textsMapping}
                inputType="text"
                inputLabel={textsMapping.companyDetailsNameLabel}
                placeHolder={textsMapping.companyDetailsNamePlaceholder}
                path="customerData.companyInvoiceDetails.selectedCompany.name"
                required
                maxLength="50"
              />

              <Input
                inputType="radio"
                radioGroupName="defaultCountryBilling"
                radioButtons={[
                  {
                    name: textsMapping.countryRadioButtonNetherlands,
                    value: true,
                  },
                  { name: textsMapping.countryRadioButtonOther, value: false },
                ]}
                defaultValue={true}
                path="customerData.companyInvoiceDetails.selectedCompany.address.defaultCountry"
                classNames="grid-cell-6"
                onChangeFunction={defaultCountryRadioButtonChanged}
              />

              {customerData.companyInvoiceDetails.selectedCompany &&
                customerData.companyInvoiceDetails.selectedCompany.address &&
                customerData.companyInvoiceDetails.selectedCompany.address
                  .defaultCountry !== undefined &&
                !customerData.companyInvoiceDetails.selectedCompany.address
                  .defaultCountry && (
                  <Select
                    resourcedTexts={textsMapping}
                    inputLabel={textsMapping.homeAddressCountryLabel}
                    options={countries}
                    path="customerData.companyInvoiceDetails.selectedCompany.address.country"
                    placeHolder={textsMapping.countrySelectDefaultValue}
                    required
                  />
                )}

              <Input
                resourcedTexts={textsMapping}
                inputType="text"
                inputLabel={textsMapping.homeAddressZipLabel}
                placeHolder={textsMapping.homeAddressZipPlaceholder}
                onBlurFunction={getCompanyAddressDetails}
                path="customerData.companyInvoiceDetails.selectedCompany.address.zip"
                classNames="grid-cell-3"
                required
              />

              <Input
                resourcedTexts={textsMapping}
                inputType="number"
                inputLabel={textsMapping.homeAddressHouseNumberLabel}
                placeHolder={textsMapping.homeAddressHouseNumberPlaceholder}
                onBlurFunction={getCompanyAddressDetails}
                path="customerData.companyInvoiceDetails.selectedCompany.address.houseNumber"
                classNames="grid-cell-3"
                required
              />

              <Input
                resourcedTexts={textsMapping}
                inputType="text"
                inputLabel={textsMapping.homeAddressHouseNumberAdditionLabel}
                placeHolder={
                  textsMapping.homeAddressHouseNumberAdditionPlaceholder
                }
                path="customerData.companyInvoiceDetails.selectedCompany.address.houseNumberAddition"
                classNames="grid-cell-3"
              />

              <Input
                resourcedTexts={textsMapping}
                inputType="text"
                inputLabel={textsMapping.homeAddressStreetLabel}
                placeHolder={textsMapping.homeAddressStreetPlaceholder}
                path="customerData.companyInvoiceDetails.selectedCompany.address.street"
                required
              />

              <Input
                resourcedTexts={textsMapping}
                inputType="text"
                inputLabel={textsMapping.homeAddressCityLabel}
                placeHolder={textsMapping.homeAddressCityPlaceholder}
                path="customerData.companyInvoiceDetails.selectedCompany.address.city"
                required
              />

              {companyAddressNotFoundErrorMessage && (
                <p className="address-error-messsage">
                  {companyAddressNotFoundErrorMessage}
                </p>
              )}

              <Input
                resourcedTexts={textsMapping}
                inputType="text"
                inputLabel={textsMapping.companyDetailsOrderReferenceLabel}
                placeHolder={
                  textsMapping.companyDetailsOrderReferencePlaceholder
                }
                errorMessage={textsMapping.inputErrorMessageOrderReference}
                path="customerData.companyInvoiceDetails.companyOrderReference"
                maxLength="50"
              />

              <Input
                resourcedTexts={textsMapping}
                inputType="email"
                inputLabel={textsMapping.companyDetailsEmailLabel}
                placeHolder={textsMapping.companyDetailsEmailPlaceholder}
                path="customerData.companyInvoiceDetails.companyInvoiceEmail"
                errorMessage={textsMapping.inputErrorMessageEmail}
                required
                onBlurFunction={trimInput}
              />
            </section>

            <section className="checkout-section">
              <h3 className="checkout-section__title">
                {textsMapping.billingDataCompanyContactTitle}
              </h3>

              <p>{textsMapping.billingDataCompanyContactText}</p>

              <Input
                resourcedTexts={textsMapping}
                inputType="text"
                inputLabel={textsMapping.companyDetailsContactPhoneLabel}
                placeHolder={textsMapping.companyDetailsContactPhonePlaceholder}
                path="customerData.companyInvoiceDetails.selectedCompany.companyContactPhone"
                onBlurFunction={trimInput}
                required
              />

              <Input
                resourcedTexts={textsMapping}
                inputType="email"
                inputLabel={textsMapping.companyDetailsContactEmailLabel}
                placeHolder={textsMapping.companyDetailsContactEmailPlaceholder}
                path="customerData.companyInvoiceDetails.selectedCompany.companyContactEmail"
                errorMessage={textsMapping.inputErrorMessageEmail}
                required
                onBlurFunction={trimInput}
              />
            </section>
          </>
        )}
      </section>
    );
  }
}

export { BillingData };
